import { Error, LicenseKeyNew, SearchIcon, ThreeDotIcon, Tick } from "icons";
import styles from "./styles.module.scss";
import { Space, Table, Tag } from "antd";
import { ThreedDownloadIconNew } from "pages/results/icons";

export const AssignmentTable = () => {
  const columns = [
    {
      title: "ID",
      dataIndex: "key",
      key: "key",
      // render: (text, record, index) => {
      //   const globalIndex = ((currentPage || 1) - 1) * pageSize + index + 1;
      //   return index < 9 && currentPage === 1 ? `0${index + 1}` : globalIndex;
      //   // const globalIndex = ((currentPage || 1) - 1) * pageSize + index + 1;
      //   // return index < 9 && currentPage === 1 ? `0${index + 1}` : globalIndex;
      // },
      width: "7%",
      fixed: "left",
    },
    {
      title: "First Name",
      dataIndex: "username",
      key: "username",
      width: "12%",
    },
    {
      title: "Last Name",
      dataIndex: "systemName",
      key: "systemName",
      width: "12%",
      ellipsis: true,
    },
    {
      title: "Email Address",
      dataIndex: "emailAddress",
      key: "emailAddress",
      width: "20%",
      ellipsis: true,
    },
    {
      title: "Status",
      dataIndex: "is_expired",
      key: "is_expired",
      width: "8%",
      render: (_, record) => {
        const isStatusActive = !record?.is_expired;

        const status = record?.is_expired ? "Remove" : "Assign";

        const colors = {
          lightRed: "#F63E504D",
          lightGreen: "#A8D3BF",
          red: "#F63E50",
          green: "#16A665",
        };
        const { lightGreen, lightRed, red, green } = colors;

        const Icon = isStatusActive ? Tick : Error;
        const color = isStatusActive ? lightGreen : lightRed;

        return (
          <Space size="middle">
            <Tag
              icon={<Icon height={14} width={14} />}
              color={color}
              bordered={true}
              style={{
                color: isStatusActive ? green : red,
                border: `1px solid ${isStatusActive ? green : red}`,
                display: "flex",
                alignItems: "center",
                gap: "3px",
                justifyContent: "center",
              }}
            >
              {status}
            </Tag>
          </Space>
        );
      },
    },

    {
      title: "Action",
      key: "action",
      width: "10%",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <span>
            <ThreeDotIcon />
          </span>
        </Space>
      ),
    },
  ];
  const data = [
    {
      key: "1",
      username: "Alina",
      systemName: "Cristino",
      emailAddress: "someone@example.com",
      is_expired: true,
      remoteAccess: 9876452,
    },
    {
      key: "2",
      username: "Alina",
      systemName: "Cristino",
      emailAddress: "someone@example.com",
      is_expired: false,
      remoteAccess: "Add AnyDesk",
    },
    {
      key: "3",
      username: "Alina",
      systemName: "Cristino",
      emailAddress: "someone@example.com",
      is_expired: false,
      remoteAccess: 9876452,
    },
    {
      key: "4",
      username: "Alina",
      systemName: "Cristino",
      emailAddress: "someone@example.com",
      is_expired: true,
      remoteAccess: 9876452,
    },
    {
      key: "5",
      username: "Alina",
      systemName: "Cristino",
      emailAddress: "someone@example.com",
      is_expired: true,
      remoteAccess: 9876452,
    },
    {
      key: "6",
      username: "Alina",
      systemName: "Cristino",
      emailAddress: "someone@example.com",
      is_expired: true,
      remoteAccess: "Add AnyDesk",
    },
    {
      key: "7",
      username: "Alina",
      systemName: "Cristino",
      emailAddress: "someone@example.com",
      is_expired: true,
      lastCaptured: "3 days ago",
      lastSession: "03.03.25",
      subscriptionStatus: "Expired",
      lastCommunicated: "03.03.25",
      remoteAccess: "Add AnyDesk",
    },
    {
      key: "8",
      username: "Alina",
      systemName: "Cristino",
      emailAddress: "someone@example.com",
      is_expired: true,
      lastCaptured: "3 days ago",
      lastSession: "03.03.25",
      subscriptionStatus: "Expired",
      lastCommunicated: "03.03.25",
      remoteAccess: 9876452,
    },
    {
      key: "9",
      username: "Alina",
      systemName: "Cristino",
      emailAddress: "someone@example.com",
      is_expired: true,
      remoteAccess: 9876452,
    },
    {
      key: "10",
      username: "Alina",
      systemName: "Cristino",
      emailAddress: "someone@example.com",
      is_expired: true,
      remoteAccess: 9876452,
    },
    {
      key: "11",
      username: "Alina",
      systemName: "Cristino",
      emailAddress: "someone@example.com",
      is_expired: true,
      remoteAccess: 9876452,
    },
    {
      key: "12",
      username: "Alina",
      systemName: "Cristino",
      emailAddress: "someone@example.com",
      is_expired: true,
      remoteAccess: 9876452,
    },
    {
      key: "13",
      username: "Alina",
      systemName: "Cristino",
      emailAddress: "someone@example.com",
      is_expired: true,
      remoteAccess: 9876452,
    },
  ];
  return (
    <div className={styles.assignmentTableContainer}>
      <div className={styles.detailAndSearch}>
        <div className={styles.details}>
          <LicenseKeyNew />
          <div className={styles.label}> License Assignment </div>
          <div className={styles.value}>
            <span>6</span>/10
          </div>
          <div className={styles.smallLable}>users selected</div>
        </div>
        <div className={styles.inputContainer}>
          <SearchIcon />
          <input type="text" placeholder="Enter a Name or Email" />
        </div>
      </div>
      <div className={styles.assignmentTable}>
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          scroll={{
            y: 400,
          }}
        />
      </div>
    </div>
  );
};
